import Evaluation from "../../Evaluation"
import { RemoteConfigParameter } from "../../../model/model"
import RemoteConfigEvaluateResult from "./RemoteConfigEvaluateResult"

export default class RemoteConfigEvaluation implements Evaluation {
  constructor(readonly entity: RemoteConfigParameter, readonly result: RemoteConfigEvaluateResult) {}
}
